import "../styles/post_item.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PostItem(props) {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Rotate images every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (props.images && props.images.length > 1) {
        setCurrentImageIndex((prevIndex) =>
          (prevIndex + 1) % props.images.length
        );
      }
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval); // Cleanup
  }, [props.images]);

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  return (
    <div className="post">
      <div className="blob">
        <img src={`/api/${props.images?.[currentImageIndex]}`} alt="" />
      </div>
      <div className="detail">
        <h3>{props.title}</h3>
        <p>{props.date}</p>
        <p dangerouslySetInnerHTML={{ __html: truncateText(props.details, 125) }}></p>
        <button
          onClick={() =>
            navigate(`/newsandevents/post/${props.id}`, { state: { ...props } })
          }
        >
          {`More >>`}
        </button>
      </div>
    </div>
  );
}
